import { ButtonBase, Typography } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
import { useCommonWebTranslation } from '../../hooks';
export const SkipToContent = () => {
    const { t } = useCommonWebTranslation();
    return (React.createElement(ButtonBase, { centerRipple: true, sx: {
            position: 'absolute',
            top: -64,
            left: 32,
            pt: 2,
            pb: 2,
            pl: 4,
            pr: 4,
            bgcolor: 'background.paper',
            color: themeColors.accent.blue.bold,
            textDecoration: 'none',
            borderRadius: 1,
            boxShadow: (theme) => theme.shadows[4],
            transition: (theme) => theme.transitions.create('top'),
            zIndex: (theme) => theme.zIndex.appBar + 1,
            '&:focus': {
                top: 32,
            },
        }, onClick: () => {
            var _a;
            (_a = window.document.getElementById('main-content')) === null || _a === void 0 ? void 0 : _a.focus();
        } },
        React.createElement(Typography, { sx: { whiteSpace: 'nowrap' } }, t('common.skipToContent'))));
};
